import { render, staticRenderFns } from "./CargoImport.vue?vue&type=template&id=6128d7f6"
import script from "./CargoImport.vue?vue&type=script&lang=js"
export * from "./CargoImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports